// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';
import YunblyMark from '@app/media/images/yunbly-mark.svg?react';
import type React from 'react';

export const APPLICATION_ICON_DESCRIPTOR = msg({
	message: '{productName} application icon',
	comment: 'Accessible label for the application icon.',
});

export const FluxerIconMark = (props: React.SVGProps<SVGSVGElement>) => (
	<YunblyMark role="img" data-flx="ui.icons.fluxer-icon.img" {...props} />
);
